<template>
  <button
    type="button"
    class="block relative bg-nucleus-white border-2 border-nucleus-primaryBlue p-2 text-nucleus-text text-center text-lg w-full rounded-full transition align-center flex items-center justify-center"
  >
    <span
      v-if="loading"
      class="absolute w-full h-full top-0 left-0 rounded-full bg-nucleus-primaryBlue text-white flex justify-center items-center"
    >
      <span
        class="loader ease-linear rounded-full border-2 border-t-2 border-nucleus-primaryMouseOver h-6 w-6 animate-spin"
      ></span
    ></span>
    <span v-if="icon" class="icon-add text-3xl mr-4 leading-none"></span>
    {{ name }}
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    loading: Boolean,
    icon: Boolean,
  },
})
export default class AddButton extends Vue {}
</script>

<style lang="scss" scoped>
.loader {
  border-top-color: #ffffff;
}
</style>
